import React from 'react';
import { ArrowRight } from 'lucide-react';

const RIDING_STYLES = [
  {
    id: 'city',
    title: 'Ciudad y Cortos',
    subtitle: 'Agilidad Urbana',
    image: 'https://images.unsplash.com/photo-1762529482442-82aa8de06fcc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY29vdGVyJTIwbW90b3JjeWNsZSUyMGNpdHklMjB1cmJhbiUyMHJpZGluZ3xlbnwxfHx8fDE3NzA2OTkzNDh8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    recommendation: 'Recomendado: JET',
    color: '#FF7F32' // Orange
  },
  {
    id: 'touring',
    title: 'Turismo y Viajes',
    subtitle: 'Largas Distancias',
    image: 'https://images.unsplash.com/photo-1768410318116-9b6bcb7ec927?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwdG91cmluZyUyMGFkdmVudHVyZSUyMHJvYWQlMjBoaWdod2F5fGVufDF8fHx8MTc3MDY5OTM0N3ww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    recommendation: 'Recomendado: Modular',
    color: '#459EDF' // Light Blue
  },
  {
    id: 'sport',
    title: 'Sport / Racing',
    subtitle: 'Velocidad y Circuito',
    image: 'https://images.unsplash.com/photo-1758887698736-16f4a8a76718?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwcmFjaW5nJTIwdHJhY2slMjBzcG9ydGJpa2UlMjBoZWxtZXR8ZW58MXx8fHwxNzcwNjk5MzQ3fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    recommendation: 'Recomendado: Integral',
    color: '#061970' // Navy
  },
  {
    id: 'offroad',
    title: 'Off-Road',
    subtitle: 'Tierra y Aventura',
    image: 'https://images.unsplash.com/photo-1746690818493-128cb32d23a9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3RvY3Jvc3MlMjBkaXJ0JTIwYmlrZSUyMGp1bXBpbmclMjBtdWR8ZW58MXx8fHwxNzcwNjk5MzQ3fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    recommendation: 'Recomendado: Cross',
    color: '#10B981' // Green
  }
];

interface RidingStyleSelectorProps {
    onSelect: (styleId: string) => void;
}

export const RidingStyleSelector: React.FC<RidingStyleSelectorProps> = ({ onSelect }) => {
  return (
    <div className="py-20 bg-[#F9FAFB]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
            <h2 className="text-4xl font-black italic text-[#061970] uppercase tracking-tighter mb-4">
                Elige tu <span className="text-[#FF7F32]">Estilo</span>
            </h2>
            <p className="text-gray-500 max-w-2xl mx-auto">
                Selecciona cómo conduces y te mostraremos el equipo perfecto para ti.
            </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {RIDING_STYLES.map((style) => (
            <div 
                key={style.id} 
                onClick={() => onSelect(style.id)}
                className="group relative h-[400px] rounded-2xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Background Image */}
              <img 
                src={style.image} 
                alt={style.title} 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block px-2 py-1 mb-3 text-[10px] font-bold uppercase tracking-widest bg-white/20 backdrop-blur rounded text-white border border-white/20">
                    {style.subtitle}
                </span>
                <h3 className="text-2xl font-black italic uppercase tracking-tighter mb-2 leading-none">
                  {style.title}
                </h3>
                <p className="text-sm text-gray-300 font-medium mb-4 flex items-center gap-2">
                   <span className="w-2 h-2 rounded-full" style={{ backgroundColor: style.color }}></span>
                   {style.recommendation}
                </p>
                
                <div className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-[#FF7F32]">
                  Ver Colección <ArrowRight className="w-4 h-4" />
                </div>
              </div>
              
              {/* Border Accent on Hover */}
              <div className="absolute inset-0 border-4 border-transparent group-hover:border-[#FF7F32]/50 transition-colors duration-300 rounded-2xl pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
